import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import { useRouter } from "vue-router";
import ResponseData from "@/types/ResponseData";
import SignUpUserService from "@/services/SignUpUserInfoDataService";
import { store } from "@/store/store";
import Alert from "@/components/scan/parts/Alert.vue";
import Loading from "@/components/home/Loading.vue";
import Navigation from "@/components/NavigationContainer.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const router = useRouter();
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const userId = ref("");
const givenName = ref("");
const familyName = ref("");
const email = ref("");
const StationCode = ref("");
const companyName = ref("");
const deptCode = ref("");
const title = ref("");
const agreement = ref(false);
const userIdError = ref("");
const givenNameError = ref("");
const familyNameError = ref("");
const emailError = ref("");
const deptError = ref("");
const titleError = ref("");
const stationError = ref("");
const successful = ref(true);
const chkStCDdata = ref("");
const chkIDdata = ref("");
const departmentList = reactive([]);
const selectedDept = ref("");
const beforeChangeFName = ref("");
const beforeChangeGName = ref("");

onMounted(function () {
  isLoading.value = true;
  getDepartmentInfo();
  //「User Permission」画面の「Back」ボタン押す時、画面データセット
  setData();
});

const setData = () => {
  userId.value = store.getters.cognitoUserName;
  givenName.value = store.getters.givenName;
  familyName.value = store.getters.familyName;
  email.value = store.getters.email;
  StationCode.value = store.getters.stationCode;
  if (StationCode.value == "1000") {
    selectedDept.value = selectedDept.value == "" ? store.getters.department : selectedDept.value;
  } else {
    deptCode.value = store.getters.department;
  }
  title.value = store.getters.title;
  companyName.value = store.getters.companyName;
};

const getDepartmentInfo = () => {
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";
  selectedDept.value = "";
  departmentList.splice(0);

  // get Department Information
  SignUpUserService.getDepartmentInfo()
    .then((response: ResponseData) => {
      if (response.data.length != 0) {
        for (let dept of response.data) {
          departmentList.push(dept);
        }
        if (store.getters.department == "") {
          selectedDept.value = departmentList[0].group;
        } else {
          selectedDept.value = store.getters.department;
        }
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      isLoading.value = false;
    });
};

const stationCodeChange = (event: { target: { value: any; }; }) => {
  StationCode.value = event.target.value;
  if (StationCode.value == "1000") {
    deptCode.value = "";
    selectedDept.value = departmentList[0].group;
  } else {
    selectedDept.value = departmentList[0].group;
  }
};


//[Go to Permission Set]ボタン押す
const goToPage = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  successful.value = true;
  StationCode.value = StationCode.value.toUpperCase();

  //[Employee Number]のチェック
  if (!userId.value.trim()) {
    userIdError.value = i18n.t("alt012");
    successful.value = false;
  } else if (!validUserID(userId.value.trim())) {
    userIdError.value = i18n.t("alt013");
    successful.value = false;
  } else {
    userIdError.value = "";
    // 2023/05/18 MDCR 修正 start(同じstationCodeで違うempnoがあるので)
    const data = {
      userId: userId.value,
      stationCode: StationCode.value
    }
    // 2023/05/18 MDCR 修正 end

    SignUpUserService.getEmployeeIDData(data)
      .then((response: ResponseData) => {
        if (response.data.length == 0) {
          chkIDdata.value = "T";
          userIdError.value = "";
        }
        else {
          // 2023/05/18 MDCR 修正 start(チェック条件変更したので)
          userIdError.value = i18n.t("alt070");
          // 2023/05/18 MDCR 修正 end
          chkIDdata.value = "F";
        }
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err020");
        alertState.value = "error";
        isLoading.value = false;
      });
  }

  //[Given Name]のチェック
  if (!givenName.value.trim()) {
    givenNameError.value = i18n.t("alt015");
    successful.value = false;
  } else if (checkSpecialCharacter(givenName.value.trim())) {
    givenNameError.value = i18n.t("alt016");
    successful.value = false;
  } else {
    givenNameError.value = "";
  }

  //[Family Name]のチェック
  if (!familyName.value.trim()) {
    familyNameError.value = i18n.t("alt017");
    successful.value = false;
  } else if (checkSpecialCharacter(familyName.value.trim())) {
    familyNameError.value = i18n.t("alt018");
    successful.value = false;
  } else {
    familyNameError.value = "";
  }

  //[Department]のチェック
  if (StationCode.value == "1000") {
    if (selectedDept.value == "") {
      deptError.value = i18n.t("alt019");
      successful.value = false;
    } else {
      deptError.value = "";
    }
  } else {
    if (checkSpecialCharacter(deptCode.value)) {
      deptError.value = i18n.t("alt019");
      successful.value = false;
    } else {
      deptError.value = "";
    }
  }

  //[Title]のチェック
  if (title.value) {
    if (checkSpecialCharacter(title.value)) {
      titleError.value = i18n.t("alt020");
      successful.value = false;
    } else {
      titleError.value = "";
    }
  }

  //[E-mail]のチェック
  if (!email.value) {
    emailError.value = i18n.t("alt021");
    successful.value = false;
  } else if (!validEmail(email.value)) {
    emailError.value = i18n.t("alt022");
    successful.value = false;
  } else if (StationCode.value == "1000" && email.value.substring(email.value.indexOf("@") + 1) != "hhq.suzuki.co.jp") {
    emailError.value = i18n.t("alt081");
    successful.value = false;
  } else {
    emailError.value = "";
  }

  //[Station Code]のチェック
  if (!StationCode.value) {
    stationError.value = i18n.t("alt023");
    successful.value = false;
  } else {
    const data = {
      stationCode: StationCode.value,
      companyName: "",
      threeDigit: "",
    };

    SignUpUserService.getStationData(data)
      .then((response: ResponseData) => {
        if (response.data.length == 0) {
          stationError.value = i18n.t("alt024");
          chkStCDdata.value = "F";
          checkmsg(chkStCDdata.value);
        } else {
          companyName.value = response.data[0].companyName;
          stationError.value = "";
          chkStCDdata.value = "T";
          checkmsg(chkStCDdata.value);
        }
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err018");
        alertState.value = "error";
        isLoading.value = false;
      });
  }
};

const checkmsg = (chkData: string) => {
  if (chkIDdata.value == "T") {
    if (chkData == "T" && successful.value == true) {
      store.dispatch("setUsername", userId.value);
      store.dispatch("setGivenName", givenName.value);
      store.dispatch("setFamilyName", familyName.value);
      store.dispatch("setEmail", email.value);
      if (StationCode.value == "1000") {
        store.dispatch("setDepartment", selectedDept.value);
      } else {
        store.dispatch("setDepartment", deptCode.value);
      }
      store.dispatch("setTitle", title.value);
      store.dispatch("setStationCode", StationCode.value);
      store.dispatch("setCompanyName", companyName.value);
      router.push({ path: "/UserPermission" });
    }
  }
};

const validUserID = (userID: string | any[]) => {
  var re = /^[A-Za-z0-9]+$/;
  var isValidUser = re.test(userID);
  if (isValidUser && StationCode.value == '1000') {
    isValidUser = userID.length != 6 ? false : true;
  }
  return isValidUser;
};

const checkSpecialCharacter = (userName: string) => {
  var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
  return re.test(userName);
};

const validEmail = (email: any) => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

onUpdated(function () {
  isLoading.value = false;
});

const txtOnKeyDown = (event: { target: { value: any; }; }) => {
  var re = /^[A-Za-z ]+$/;
  beforeChangeFName.value = re.test(familyName.value) ? familyName.value : beforeChangeFName.value;
  beforeChangeGName.value = re.test(givenName.value) ? givenName.value : beforeChangeGName.value;
}
const checkAlphabet = (event: { target: { value: any; }; }) => {
  var re = /^[A-Za-z ]+$/;
  if (!re.test(event.target.value) && event.target.value != "") {
    familyName.value = beforeChangeFName.value;
    givenName.value = beforeChangeGName.value;
  }
  return;
}

const __returned__ = { isLoading, router, alertMessage, alertState, i18n, userId, givenName, familyName, email, StationCode, companyName, deptCode, title, agreement, userIdError, givenNameError, familyNameError, emailError, deptError, titleError, stationError, successful, chkStCDdata, chkIDdata, departmentList, selectedDept, beforeChangeFName, beforeChangeGName, setData, getDepartmentInfo, stationCodeChange, goToPage, checkmsg, validUserID, checkSpecialCharacter, validEmail, txtOnKeyDown, checkAlphabet, Alert, Loading, Navigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})